import BaseNodeQueue from './BaseNodeQueue';
import { LINE_DIR, SHAP_TYPE , EFFECT_TAG }  from '../../enums/index';


/**
* 基础节点的链表
*/
class CircleLineNodeQueue extends BaseNodeQueue {
  constructor(props) {
    super(props);
  }

  // 获取最后一根线和点
  getLastLineAndCircle() {
    const lastNode = this.lastNode;

    return {
      lastLine: (lastNode || {}).pre || null,
      lastCircle: lastNode
    }
  }

  /**
   * 获取某个节点链表后所有的线和点 array数据
   * @param {*} firstNode 可不传 不传就是所有线和点
   * @returns 
   */
  getLineAndCircleOnQueue(firstNode = null, drawLayerId = null) {
    let curNode = firstNode || this.firstNode;
    const lineList = [];
    const circleList = [];

    while(curNode) {      
      switch (curNode.shapeType) {
        case SHAP_TYPE.LINE:
          lineList.push(curNode);
          break;
        case SHAP_TYPE.CIRCLE:
          circleList.push(curNode);
          break;
      }

      curNode = curNode.next;
    }

    return {
      lineList,
      circleList
    }
  }

  // 根据副作用找出所有挪动过的线
  findAllMoveEffectLine() {
    const { lineList } = this.getLineAndCircleOnQueue();

    // 首个有副作用移动的线
    return lineList.filter(line =>
      (line.flags & EFFECT_TAG.POINTS) === EFFECT_TAG.POINTS &&
      line.shapeType === SHAP_TYPE.LINE
    )
  }

  // 移除最后一条线和点
  clearLastLine() {
    const { lastLine } = this.getLastLineAndCircle();

    if (!lastLine) return;

    // 有线必有点
    const preCircle = lastLine.pre;

    preCircle.next = null;

    this.lastNode = preCircle;
  }

  // 获取所有线的长度
  getLineSize() {
    const { lastLine } = this.getLastLineAndCircle();

    return lastLine ? lastLine.renderData.endSize : 0;
  }

  getMainLineByLongest(count) {
    const {
      lineList,
    } = this.getLineAndCircleOnQueue();

    const nodeList = lineList.filter(line => [ LINE_DIR.ROWLR, LINE_DIR.ROWRL, LINE_DIR.COLTB, LINE_DIR.COLBT ].includes(line.renderData.direction));
    const sortNodeList = nodeList.slice().sort((a, b) => b.renderData.size - a.renderData.size);
    const minSizeNode = (sortNodeList[count - 1] || { renderData: {size: 0 }}).renderData.size;

    return {
      nodeList: nodeList
        .filter(line => line.renderData.size >= minSizeNode).slice(0, count)
    }
  }

  // 获取所有线的长度
  getMainLine() {
    const {
      lineList,
    } = this.getLineAndCircleOnQueue();

    let rowSize = 0;
    let colSize = 0;
    const rowList = [];
    const colList = []

    lineList.forEach(node => {
      // 线方向  ROWLR 横向 左 -> 右 ROWRL 横向 右 -> 左 COLTB 纵向 上 -> 下 COLBT 纵向 下 -> 上
      if ([ LINE_DIR.ROWLR, LINE_DIR.ROWRL ].includes(node.renderData.direction)) {
        rowSize += node.renderData.size;
        rowList.push(node)
      } else {
        colSize += node.renderData.size;
        colList.push(node)
      }
    })

    return {
      direction: LINE_DIR.ROW,
      size: rowSize,
      nodeList: lineList
    }
    // if (rowSize >= colSize) {
    //   return {
    //     direction: LINE_DIR.ROW,
    //     size: rowSize,
    //     nodeList: rowList
    //   }
    // } else {
    //   return {
    //     direction: LINE_DIR.COL,
    //     size: colSize,
    //     nodeList: colList
    //   }
    // }
  }

}

export default CircleLineNodeQueue;